import GameState from "slotworks/model/game-state";
import GambleRecord from "slotworks/model/gameplay/records/gamble-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class IsGambleRecovery extends Decision {
    public evaluate() {
        return GameState.getCurrentGame().getCurrentRecord() instanceof GambleRecord ? Exit.True : Exit.False;
    }
}
